export default __webpack_public_path__ + "4e67902d782a1f23b1a73e5f0fa1efdf.png";